export const PRIMARY_COLORS = [
  { value: "#284b40", en: "Forest", he: "יער" },
  { value: "#630e25", en: "Burgundy", he: "בורדו" },
  { value: "#243b53", en: "Midnight blue", he: "כחול לילה" },
  { value: "#583750", en: "Plum", he: "שזיף" },
];
export const SECONDARY_COLORS = [
  { value: "#b4a16b", en: "Antique gold", he: "זהב עתיק" },
  { value: "#d5bd91", en: "Sand", he: "חול" },
  { value: "#adc2ac", en: "Sage", he: "מרווה" },
  { value: "#d4adb2", en: "Rose", he: "ורוד עתיק" },
];
export function themeVariables(primary = "#284b40", secondary = "#b4a16b") {
  return {
    "--primary": primary,
    "--secondary": secondary,
    "--primary-soft": `${primary}0d`,
    "--secondary-soft": `${secondary}25`,
  } as React.CSSProperties;
}
